import React from 'react';

class UserVideo extends React.Component {

    render() {
        return (
            <div>
                <iframe src="https://drive.google.com/file/d/1Q6BZ4dEatNZFja__DSg20WSkCL5Cmzi4/preview" width="640" height="480"></iframe>
            </div>
        );
    }
}

export default UserVideo;